export default Object.freeze({
  AUDIT_LOGS_LIST: 'AUDIT_LOGS_LIST',
});
